<div class="card">
  <div class="card-body" *ngIf="account">
    <div>
      <a routerLink="/au/accounts/{{ account.id }}">
        <h5>{{ account.displayName }}</h5>
      </a>
      {{ accountCategoriesMap(account.category) }} <br />
      Id: {{ account.id }} <br />
      <button
        class="btn btn-link"
        (click)="goToOneAsStaffUser()"
        *ngIf="showGoToAccountLink"
      >
        <i class="fas fa-sign-in-alt"></i> Go to account as Staff User
      </button>
      <hr />
    </div>

    <div class="d-flex justify-content-end">
      <a
        routerLink="/au/accounts/{{ account.id }}/users/{{ userId }}"
        class="btn btn-primary"
        ngbTooltip="Show and edit permissions for {{ userName }} on {{
          account.id
        }}."
      >
        <i class="fas fa-lock"></i> Permissions
      </a>
    </div>
  </div>
</div>
